const getNumberTitle = ({ operator, value, title = '' }) => {
  const ratingOperators = {
    between: () => `${value[0]} - ${value[1]}`,
    gt: () => `> ${value}`,
    lt: () => `< ${value}`,
    equals: () => `= ${value}`,
    notEquals: () => `≠ ${value}`,
    isSet: () => `${title} set`,
    notSet: () => `${title} not set`,
  };

  return ratingOperators[operator]?.() || title;
};

export default getNumberTitle;
